import React from "react";
import styled from "styled-components";
import 배경이미지 from "../assets/home.png";
import HomeButton from "./HomeButton";
import Notice from "./Notice";

const Inventory = () => {
  return (
    <Container>
      <Notice positionStatic />
      Inventory
      <ButtonWrapper>
        <HomeButton />
      </ButtonWrapper>
    </Container>
  );
};

export default Inventory;

const Container = styled.div`
  margin: auto;

  max-width: 420px;
  height: 100vh;

  /* min-height: 650px; */
  /* background-color: pink; */

  position: relative;
  background-image: url(${배경이미지});

  padding: 20px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
`;
